<template>
  <div v-if="flag" class="bot-banner">
    <div class="bot-banner-wrap">
      <img src="@/assets/index/banner.png" alt="" @click="toSend">
      <div class="close-btn" @click="close">
        <a-icon type="close-circle" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      flag: this.show
    }
  },
  computed: {

  },
  watch: {
    show(val) {
      this.flag = val
    },
    flag(val) {
      this.$emit('update:show', val)
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    close() {
      this.flag = false
    },
    toSend() {
      this.$router.push({
        name: 'Send'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.bot-banner{
    position:fixed;
    height:100px;
    width:100%;
    bottom:0px;
    left:0;
    background:rgba(0,0,0,0);
    z-index: 100;
    .bot-banner-wrap{
        position: absolute;
        transform: translateX(-50%);
        left:50%;
        bottom:5px;
        img{
            cursor: pointer;
        }
        .close-btn{
            position:absolute;
            top:-2px;
            right:-14px;
            color:#a5a5a5;
            cursor:pointer;
            transition:all ease 0.2s;
            i{
                font-size:22px;
            }
        }
        .close-btn:hover{
            i{
                color:#1890FF;
            }
        }
    }
}
</style>
